<template>
  <div>

    <v-overlay>
      <v-row class="justify-center">
        <v-img
        :src="require('@/assets/HIES.png')"
          max-height="150px"
          max-width="150px"
          alt="logo"
          contain
          class="me-3"
        ></v-img>
      </v-row>
      <v-row class="justify-center">
        <p><span class="blink_text">PERHATIAN!!!..</span></p><br>
      </v-row>
      <v-row class="justify-center">
        <p>Sila buat pengisian di Blok 3 PreCode bagi KodItem yang telah ditetapkan selain daripada KodItem di Blok 3!!!</p><br> 
      </v-row>
      <v-row class="justify-end">
        <p>Ditutup <span class="blink_text">{{ countDown }} </span>saat</p><br> 
      </v-row>
    </v-overlay>
  
  </div>
</template>

<script type="text/javascript">

export default {
  
  name: "Popup",
  data () {
            return {
                countDown: 3
            }
          },
  
          methods: {
            countDownTimer () {
                if (this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            }
        },
        created () {
            this.countDownTimer()
        }
  
};

</script>
<style>
.blink_text {
 animation-name: blinker;
 animation-duration: 1s;
 animation-timing-function: linear;
 animation-iteration-count: infinite;
}

@keyframes blinker {  
 0% { opacity: 1.0; }
 50% { opacity: 0.0; }
 100% { opacity: 1.0; }
}
</style>




